import { BusinessGroupEntity } from 'src/models/AppContextModels';

export const getBusinessGroupByName = (businessGroupName: string, businessGroups: BusinessGroupEntity[]) => {
  return businessGroups.find((businessGroup) => businessGroup.data_classification.data_classification_name === businessGroupName);
};

export const getBusinessGroupById = (dataClassificationId: number, businessGroups: BusinessGroupEntity[]) => {
  return businessGroups.find((businessGroup) => businessGroup.data_classification.data_classification_id === dataClassificationId);
};
